export const iconFontAwesomeDisasterCrisisCloudShowersWater = (
	<i className="fa-solid fa-cloud-showers-water"></i>
);
